import {
  // LabelLang,
  LabelLangString,
} from "component/LabelLang/label-lang";
// import Linkable from "component/LinkableComponent/linkable-component";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import AutoCompleteComponent from "component/shared/AutoCompleteComponent";
import Paginator from "component/shared/Paginator/Paginator";
import Dropdown from "component/shared/dropdown/Dropdown";
import { EXTERNAL_TRADE_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { displayType, reportType } from "constants/Defaults";
import { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import ChevronIcon from "svg-icons/chevron-icon";
import useSWR from "swr";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useReactToPrint } from 'react-to-print';
import ReplayIcon from '@mui/icons-material/Replay';
import SnackbarModal from "component/shared/snackbar";
import ReactGA from "react-ga4";

const ImporterExporter = () => {
  const intl = useIntl();
  const dir = useSelector(({ theme }) => theme.direction);
  const pdfImage = process.env.PUBLIC_URL + "/image/pdf.png";
  const excelImage = process.env.PUBLIC_URL + "/image/Excel.svg";
  const pdfHeader = process.env.PUBLIC_URL + "/image/pdfHeader.png";
  const pdfFooter = process.env.PUBLIC_URL + "/image/pdfFooter.png";
  const maxDate = new Date().toJSON().slice(0,10)
  const currentLocale = useSelector(({ theme }) => theme.locale);

                            
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/external-trade", title: "Export-Import-Companies External Trade Page" });
  }, []);


  const [searchTerm, setSearchTerm] = useState("");

  const countriesData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.COUNTRIES}`,
  });

  const itemsData = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.ITEMS}${
      searchTerm ? searchTerm : "default-dummy"
    }`,
  });
  const renderOptions = () => {
    const defaultOption = { id: 0, title: "", isAdvancedSearch: true };
    const emptyListOption = { id: 0, title: "", isListEmpty: true };
    if (!itemsData.data || itemsData.isLoading || itemsData.error) {
      return [defaultOption];
    }
    if (itemsData.data.data.length > 0) {
      return [...itemsData.data.data.slice(0, 10), defaultOption];
    }
    return [emptyListOption, defaultOption];
  };
  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const defaultState = {
    exporterImportersDisplay: null,
    countryId: null,
    itemId: null,
    ReportType: null,
    PageSize: 10,
    CurrentPage: 1,
  };

  const [filters, setFilters] = useState(defaultState);
  const [changeState, setChangeState] = useState(defaultState);
  const [changeCount, setChangeCount] = useState(defaultState)
  const [filterCount, setFilterCount] = useState(defaultState)
  const [itemId, setItemId] = useState(0);

  const handelFilterData = (e) => {
    let filterData = { ...changeState };
    filterData[e.target.name] = e.target.value;
    setChangeState(filterData);

    let count = { ...changeCount };
    count[e.target.name] = e.target.value;
    setChangeCount(count);
  };


  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      CurrentPage: value,
    }));
  };


  const handelChangeCountryId = (targetName) => {
    const result = countriesData?.data?.data?.find(item => `${item.code ?? item.id}` +" - "+ LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: item?.name,
      translations: item?.translations,
      }) === targetName);
    if (result) {
        const idOfTargetName = result?.id;
        setChangeState((prev) => ({
            ...prev, 
            countryId: idOfTargetName
        }));
        setChangeCount((prev) => ({
            ...prev, 
            countryId: idOfTargetName
        }));
    } 
}

  const reportFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.IMPORT_EXPORT}`,
    params: filters,
  });

  const countFetching = useSWR({
    url: `${EXTERNAL_TRADE_BASE_URL}/${END_POINTS.IMPORT_EXPORT}`,
    params: filterCount,
  });

  const [countryInfo, setCountryInfo] = useState();
  const handelChangeCountry = (e) => {
      setCountryInfo(countriesData?.data?.data.find(el => +el.id === +changeState.countryId));
  }

  const [itemInfo, setItemInfo] = useState();
  const handelChangeItem = (e) => {
      setItemInfo(itemsData?.data?.data && itemsData?.data?.data.find(el => +el.id === +itemId));
  }

  const [reportTypeInfo, setReportTypeInfo] = useState();
  const handelChangeReportType = (e) => {
    setReportTypeInfo(reportType.find(el => +el.id === +changeState.ReportType));
}
const [reportDisplayTypeInfo, setReportDisplayTypeInfo] = useState();
const handelChangeReportDisplayType = (e) => {
    setReportDisplayTypeInfo(displayType.find(el => +el.id === +changeState.exporterImportersDisplay));
}

const [hiddinLabel, setHiddinLabel] = useState(false);
const resetForm = () => {
  setHiddinLabel(true);
  setFilters(defaultState);
  setFilterCount(defaultState);
  document.querySelectorAll("select").value = 0;
  document.getElementById("combo-box-demo").style.opacity = "0";
};

  const elementPdf = useRef(null);
  const generateToPDF = useReactToPrint({
    documentTitle: `${dir === 'rtl' ? 'شركات التصدير والإستيراد' : 'Export and import companies'} - ${+filters.exporterImportersDisplay === 1 ? itemInfo?.hsn : countryInfo?.code} - ${LabelLangString({
      id: "name",
      currentLocale: currentLocale,
      defaultValue: +filters.exporterImportersDisplay === 1 ? itemInfo?.name : countryInfo?.name,
      translations: +filters.exporterImportersDisplay === 1 ? itemInfo?.translations : countryInfo?.translations,
    })}`,
    content: () => elementPdf.current,
    bodyClass: `${dir === 'rtl' ? 'exportBody-rtl' : 'exportBody-ltr'}`
  })

  const [alertEmptyData, setAlertEmptyData] = useState(false);
  const handleOpenAlert = () => {
      setAlertEmptyData(true);
  };
  const handleCloseAlert = () => {
      setAlertEmptyData(false);
  };

  return (
    <ContentLoading isLoading={countriesData.isLoading}>
      <div className="active-item-news-tabs">
        <div className="browsetopic-box alls mb-0 py-3">
          <div className="container">
            <form
              className="row gy-3"
              onSubmit={(e) => {
                e.preventDefault();
                if(
                  (changeState.ReportType && +changeState.exporterImportersDisplay === 1 && itemId) ||
                  (changeState.ReportType && +changeState.exporterImportersDisplay === 2 && changeState.countryId)
                ) {
                  handleCloseAlert();
                  handelChangeItem();
                  handelChangeCountry();
                  handelChangeReportType();
                  handelChangeReportDisplayType();
                  setFilters({ ...changeState, itemId: itemId });
                  setFilterCount({ ...changeCount, itemId: itemId, PageSize: null, CurrentPage: null });
                }
                else {
                  handleOpenAlert();
                }
              }}
            >
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="ReportType">
                    <FormattedMessage id="statement-type" />
                  </label>
                </div>
                <Dropdown
                  item={reportType}
                  name={"ReportType"}
                  placeholder={intl.formatMessage({
                    id: "choose-statement-type",
                  })}
                  change={handelFilterData}
                  required={true}
                />
              </div>
              <div className="col-12 col-lg-6 ">
                <div className="item-form coll">
                  <label htmlFor="exporterImportersDisplay">
                    <FormattedMessage id="display-type" />
                  </label>
                </div>
                <Dropdown
                  item={displayType.slice(0, 2)}
                  name={"exporterImportersDisplay"}
                  placeholder={intl.formatMessage({
                    id: "choose-display-type",
                  })}
                  change={handelFilterData}
                  required={true}
                />
              </div>
              {changeState["exporterImportersDisplay"] == "1" && (
                <div className="col-12">
                  <div className="item-form coll">
                    <label htmlFor="itemId">
                      <FormattedMessage id="item" />
                    </label>
                  </div>
                  <AsyncTypeahead
                    isLoading={false}
                    id="basic-typeahead-single"
                    labelKey={(option) => {
                      setItemId(option.id);
                      return hiddinLabel === true ? '' : option.hsn + " - " + option.name;
                    }}
                    filterBy={(option) => {
                      return option.id.toString();
                    }}
                    options={renderOptions()}
                    onSearch={handleSearch}
                    onChange={() => setHiddinLabel(false)}
                    placeholder={intl.formatMessage({ id: "search" })}
                    emptyLabel={intl.formatMessage({ id: "data-not-found" })}
                    renderMenuItemChildren={(option) => {
                      if (option.isListEmpty) {
                        return (
                          <div className="data-not-found-item">
                            <FormattedMessage id="data-not-found" />
                          </div>
                        );
                      }
                      return dir == "rtl" ? (
                        <div style={{ textAlign: "right" }}>
                          <label>
                            {/* <LabelLang 
                                id={'name'}
                                defaultValue={option.name}
                                translations={option.translations}
                            /> */}
                            {option.hsn}
                            {option.hsn && " - "}
                            {option.name?.substr(0, 92)}
                            {option.name?.length > 92 ? "... " : ""}
                          </label>
                        </div>
                      ) : (
                        <label>
                          {/* <LabelLang 
                              id={'name'}
                              defaultValue={option.name}
                              translations={option.translations}
                          /> */}
                          {option.hsn && option.translations?.length > 0
                            ? option.hsn +
                              " - " +
                              option.translations[0].name.substr(0, 92) +
                              (option.name?.length > 92 ? "... " : "")
                            : option.hsn +
                              " - " +
                              option.name?.substr(0, 92) +
                              (option.name?.length > 92 ? "... " : "")}
                          {option.name?.length > 92 ? "... " : ""}
                        </label>
                      );
                    }}
                  />
                </div>
              )}
              {changeState["exporterImportersDisplay"] == "2" && (
                <div className="col-12">
                  <div className="item-form coll">
                    <label htmlFor="countryId">
                      <FormattedMessage id="country" />
                    </label>
                  </div>
                  {countriesData?.data?.data ?
                    <AutoCompleteComponent
                      handelChange={handelChangeCountryId}
                      item={countriesData?.data?.data.map(item => ({ label: `${item.code ?? item.id}` +" - "+ LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: item?.name,
                        translations: item?.translations,
                        }) , id: item.id }))}
                    />
                    :
                    <Dropdown
                        name="countryId"
                        placeholder={intl.formatMessage({ id: "choose-country" })}
                        icon={false}
                    />
                  }
                </div>
              )}
              <div className="col-12 col-xl-3"></div>
              <div className="col-12 col-xl-9">
                <div className="row-r gap-4 my-3 align-items-center">
                  {countFetching?.data?.data?.items && Object.keys(countFetching?.data?.data?.items).length > 0 && <div className='text-white'>
                      <span>
                          <FormattedMessage id="download-data" />
                      </span>
                      <span className={`content ${dir === 'rtl' ? 'me-3' : 'ms-3'}`}>
                          <span
                            className={`sp-icon ${dir === 'rtl' ? 'ms-3' : 'me-3'}`}
                            onClick={
                                () => {
                                    generateToPDF()
                                }
                            }
                          >
                              <img src={pdfImage} style={{width: '40px' , cursor: 'pointer' , borderRadius: '6px'}} alt="pdf-image" />
                          </span>
                          <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className={`border-0 bg-transparent`}
                              table={`table-to-xls-import-export-report`}
                              filename={
                                  `${dir === 'rtl' ? 'شركات التصدير والإستيراد' : 'Export and import companies'} - ${+filters.exporterImportersDisplay === 1 ? itemInfo?.hsn : countryInfo?.code} - ${LabelLangString({
                                    id: "name",
                                    currentLocale: currentLocale,
                                    defaultValue: +filters.exporterImportersDisplay === 1 ? itemInfo?.name : countryInfo?.name,
                                    translations: +filters.exporterImportersDisplay === 1 ? itemInfo?.translations : countryInfo?.translations,
                                  })}`
                              }
                              sheet="tablexls"
                              buttonText={
                                  <span className="sp-icon">
                                      <img src={excelImage} style={{width: '40px' , cursor: 'pointer' , borderRadius: '6px'}} alt="excel-image" />
                                  </span>
                              }
                          />
                      </span>
                  </div>}
                  <button type="submit" className="main-btn">
                    <span>
                      <FormattedMessage id="view-data" />
                    </span>
                    <ChevronIcon width={12} height={12} />
                  </button>
                  <button
                    type="reset"
                    className="second-btn"
                    onClick={() => {
                      resetForm();
                    }}
                  >
                    <span>
                      <FormattedMessage id="reset" />
                    </span>
                    <ReplayIcon style={{fontSize: 20}} />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* error */}

      <SnackbarModal open={alertEmptyData} onClose={handleCloseAlert} severity="error" message={intl.formatMessage({
        id: "must_fill_all_fields",
      })} />

      <div className="body-news pt-4">
        {reportFetching?.isLoading ? (
          <h5 className="text-center" dir="ltr">
            <FormattedMessage id="loading..." />
          </h5>
        ) : reportFetching?.data?.data?.items ? (
          Object.keys(reportFetching?.data?.data?.items).length > 0 ? (
            <>
              <Table responsive striped bordered hover className="text-center">
                <thead
                  className="text-white main-bg"
                >
                  <tr>
                      <th colSpan={6}>
                        {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: reportTypeInfo?.name,
                            translations: reportTypeInfo?.translations,
                        })} - {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: reportDisplayTypeInfo?.name,
                            translations: reportDisplayTypeInfo?.translations,
                        })} - {dir === 'rtl' ? 'شركات التصدير والإستيراد' : 'Export and import companies'}
                      </th>
                  </tr>
                  <tr>
                    <th colSpan={6}>
                      {+filters.exporterImportersDisplay === 1 ? itemInfo?.hsn : countryInfo?.code} - {LabelLangString({
                        id: "name",
                        currentLocale: currentLocale,
                        defaultValue: +filters.exporterImportersDisplay === 1 ? itemInfo?.name : countryInfo?.name,
                        translations: +filters.exporterImportersDisplay === 1 ? itemInfo?.translations : countryInfo?.translations,
                      })}
                    </th>
                  </tr>
                  {/* <tr>
                    <th colSpan={6}>
                      {intl.formatMessage({
                        id: "quantity-data-under-constraction",
                      })}
                    </th>
                  </tr> */}
                  <tr>
                    {/* <th style={{ width: "10%" }}>
                      {intl.formatMessage({ id: "id" })}
                    </th> */}
                    <th style={{width: '5%'}}>#</th>
                    <th>{intl.formatMessage({ id: "name" })}</th>
                    <th>{intl.formatMessage({ id: "address" })}</th>
                  </tr>
                </thead>
                <tbody>
                  <Paginator
                    size={filters.PageSize}
                    table={true}
                    colspan={6}
                    change={onPageIndexChange}
                    page={filters.CurrentPage}
                    totalCount={reportFetching?.data?.data?.pager?.totalCount}
                  >
                    {reportFetching?.data?.data?.items.map(
                      ({ name, address }, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{name}</td>
                          <td>{address}</td>
                        </tr>
                      )
                    )}
                  </Paginator>
                </tbody>
              </Table>

              <div className="d-none">
                <div ref={elementPdf}>
                  <img
                    src={pdfHeader}
                    alt="pdf-header"
                    className="w-100"
                    style={{
                      // position: "fixed",
                      top: "5px",
                      left: 1,
                      zIndex: 100000,
                    }}
                  />
                  <Table
                    responsive
                    striped
                    bordered
                    hover
                    className="text-center"
                    id={`table-to-xls-import-export-report`}
                  >
                    <thead
                      className="text-white main-bg"
                      
                    >
                      <tr>
                        <th colSpan={6}>
                          {maxDate}
                        </th>
                      </tr>
                      <tr>
                          <th colSpan={6}>
                            {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: reportTypeInfo?.name,
                                translations: reportTypeInfo?.translations,
                            })} - {LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: reportDisplayTypeInfo?.name,
                                translations: reportDisplayTypeInfo?.translations,
                            })} - {dir === 'rtl' ? 'شركات التصدير والإستيراد' : 'Export and import companies'}
                          </th>
                      </tr>
                      <tr>
                        <th colSpan={6}>
                          {+filters.exporterImportersDisplay === 1 ? itemInfo?.hsn : countryInfo?.code} - {LabelLangString({
                            id: "name",
                            currentLocale: currentLocale,
                            defaultValue: +filters.exporterImportersDisplay === 1 ? itemInfo?.name : countryInfo?.name,
                            translations: +filters.exporterImportersDisplay === 1 ? itemInfo?.translations : countryInfo?.translations,
                          })}
                        </th>
                      </tr>
                      {/* <tr>
                        <th colSpan={6}>
                          {intl.formatMessage({
                            id: "quantity-data-under-constraction",
                          })}
                        </th>
                      </tr> */}
                      <tr>
                        <th style={{ width: "10%" }}>
                          {intl.formatMessage({ id: "id" })}
                        </th>
                        <th>{intl.formatMessage({ id: "name" })}</th>
                        <th>{intl.formatMessage({ id: "address" })}</th>
                      </tr>
                    </thead>
                    <tbody>
                        {countFetching?.data?.data?.items.map(
                          ({ name, address }, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{name}</td>
                              <td>{address}</td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </Table>
                  <img
                    src={pdfFooter}
                    alt="pdf-footer"
                    className="w-100"
                    style={{
                      // position: "fixed",
                      bottom: "10px",
                      left: 1,
                      zIndex: 100000,
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <h4 className="text-center">
              <FormattedMessage id="data-not-found" />
            </h4>
          )
        ) : (
          ""
        )}
      </div>
    </ContentLoading>
  );
};

export default ImporterExporter;
